import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Document18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.75 16.5C15.75 17.1808 15.1808 17.75 14.5 17.75H3.5C2.81917 17.75 2.25 17.1808 2.25 16.5V1.5C2.25 0.819167 2.81917 0.25 3.5 0.25H11C11.1989 0.25 11.3897 0.329018 11.5303 0.46967L15.5303 4.46967C15.671 4.61032 15.75 4.80109 15.75 5V16.5ZM3.75 16.25V1.75H9.25V6C9.25 6.41421 9.58579 6.75 10 6.75H14.25V16.25H3.75ZM14.1893 5.25H10.75V1.81066L14.1893 5.25Z'
      fill='currentColor'
    />
  </Svg>
);

Document18.displayName = 'Document18';
export default Document18;
